import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import CapitalDepositMandateeIntroPage from '../../components/IntroPage';
import locales from './locales';

interface PersonalInformationIntroProps {
  onNext: () => void;
}

const PersonalInformationIntro = asBentoPage<PersonalInformationIntroProps>(
  ({ Layout, onNext }) => (
    <Layout nav={<OBNavigation />}>
      <CapitalDepositMandateeIntroPage
        ctaLocale={locales.cta}
        description={locales.description}
        onNext={onNext}
        title={locales.title}
      />
    </Layout>
  ),
);

export default PersonalInformationIntro;
